<template>
  <div @click="onClick">
    <div class="tag-input"   :style="[ error ? borderColorRed : '', ]" v-click-outside="externalClick">
      <label
        ref="label"
        :class="{
          'label-focus': labelFocusFlag,
          'input-label': !labelFocusFlag,
        }"
      >
        {{ label }}
      </label>

      <div
        v-for="(tag, index) in tags"
        :key="tag + index"
        class="tag-input__tag"
      >
        <!-- {{ displayTagName(tag) }} -->
        <span v-if="version == 'new'">
          {{ tag[optionLabel] }}
        </span>
        <span v-if="version !== 'new'">
          {{ tag }}
        </span>
        <span @click="removeTag(index)">x</span>
      </div>

      <div>
        <input
        :type="inputType"
          class="tag-input__text"
          @keydown.enter="addTag"
          @keydown.delete="removeLastTag"
          :value="val"
          v-on:input="updateValue($event.target.value)"
          :id="id"
        />
      </div>
    </div>
    <span
          v-if="error"
          class="error-text"
          >{{ error }}</span
        >
  </div>
</template>
<script>

export default {
  data() {
    return {
      borderColorRed: {
          "border-color": "var( --text-error-color)",
          outline: "none",
          "box-shadow": "none",
        },
      tags: [],
      val: "",
      labelFocusFlag: false,
      id: this._uid,

    };
  },

  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
    },
    optionLabel: {
      type: String,
      default: "label",
    },
    version: {
      type: String,
      default: "new",
    },
    error: String,
    defaultTags: {
      type: Array,
    },
    inputType:{
      default: "text"}, // Default to text input
  },

  methods: {
    displayTagName(val) {
      return val;
    },
    addTag(event) {
      event.preventDefault();
      var val = event.target.value.trim();
      if (val.length > 0) {
        if (this.inputType === "email") {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(val)) {
            this.error = "Invalid email address";
            return;
          }
        }

        this.version == "new"
          ? this.tags.push({ [this.optionLabel]: val })
          : this.tags.push(val);
        event.target.value = "";
        this.error = ""; // Clear error message
      }
      this.$emit("enter", this.tags);
    },

    removeTag(index) {
      this.tags.splice(index, 1);
      if (this.tags.length == 0) {
        this.labelFocusFlag = !this.labelFocusFlag;
      } else if (this.tags.length > 0) {
        this.labelFocusFlag = true;
      }
      this.$emit("remove", this.tags, index);
    },

    removeLastTag(event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1);
      }
    },

    updateValue: function (value) {
      this.$emit("input", this.tags);
    },

    onClick() {
      if (this.tags.length > 0) {
        this.labelFocusFlag = true;
      } else if (this.tags.length == 0) {
        this.labelFocusFlag = !this.labelFocusFlag;
      } else {
        this.labelFocusFlag = false;
      }
      let inp = document.getElementById(this.id);
      inp.focus();
    },

    externalClick(event) {
      if (this.tags.length == 0) {
        this.labelFocusFlag = false;
      } else if (this.tags.length != 0) {
        this.labelFocusFlag = true;
      }
    },
  },

  mounted() {
    if (this.defaultTags.length > 0) {
      this.defaultTags.forEach((t) => {
        this.version == "new"
          ? this.tags.push({ [this.optionLabel]: t })
          : this.tags.push(t);
      })
    }
    var element = document.getElementById(this.id);
    this.value.length !== undefined && this.value.length > 0
      ? (this.tags = this.value)
      : "";
    this.tags.length > 0 ? (this.labelFocusFlag = true) : "";
  },
  updated() {},
  watch: {
    value: {
      deep: true,
      handler(nv, ov) {
        this.tags = nv;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.tag-input {
  width: 100%;
  border: 1px solid var(--very-light-pink);
  font-size: 14px;
  box-sizing: border-box;
  padding: 0 10px;
  word-break: break-word;
  cursor: text;
  position: relative;
    font-family: "Roboto !important";
}

.tag-input__tag {
  height: auto;
  float: left;
  margin-right: 10px;
  background-color: var(--very-light-pink);
  margin-top: 5px;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 3px;
    font-family: "Roboto !important";
}

.tag-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}

.tag-input__text {
  border: none;
  outline: none;
  font-size: 14px;
  line-height: 40px;
  background: none;
  /* width: initial; */
  font-family: "Euclid Circular B";
}
.label-focus {
  margin-top: -6px;
  margin-left: 0px !important;
  padding-right: 8px;
  padding-left: 8px !important;
  background-color: #fff;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.25;
  color: var(--black);
  text-transform: uppercase !important;
}
.input-label {
  position: absolute;
  font-size: 14px;
  line-height: 1;
  margin-top: 14px;
  margin-left: 8px;
  cursor: text;
  color: var(--brown-grey);
  text-transform: capitalize;
}
label {
  text-transform: capitalize !important;
}
.error-text {
    position: absolute;
      font-family: "Roboto !important";
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    padding-top: 2px;
    color: #ff0000;
    margin-left: 18px;
  }
</style>